@if (!hideHeader) {
  <div class="unpadded">
    <more-block id="1" content="abitekst.tunnistused"></more-block>
  </div>
  <h2>{{ 'frontpage.certificates_data' | translate }}</h2>
}
<accordion>
  <accordion-item [title]="accordionSections[0].title"
    (click)="dataController(accordionSections[0].id)">
    <ng-template>
      @if (!error && !graduationCertificates) {
        <loader></loader>
      }
      @if (graduationCertificates && graduationCertificates.length < 1) {
        <p
          class="text-center text--substrong--head mb-0">
          {{ 'frontpage.dashboard_tabs_graduation_certificates_no_results' | translate }}
        </p>
      }
      <scrollableContent>
        @if (!error && graduationCertificates && graduationCertificates.length > 0) {
          <table htm-table>
            <thead>
              <tr>
                <th>{{ 'certificates.institution_name' | translate }}</th>
                <th>{{ 'certificates.document_name' | translate }}</th>
                <th>{{ 'certificates.issuing_date' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (certificate of graduationCertificates; track certificate) {
                <tr>
                  <td>{{ certificate.issuerName }}</td>
                  <td>{{ certificate.typeName }}</td>
                  <td>
                    {{ certificate.status === 'CERTIFICATE_STATUS:VALID' ? (certificate.issued | date: 'dd.MM.yyyy') : ('generic.invalid' | translate) }}
                  </td>
                  <td>
                    <a [routerLink]="((this.usesNewDetailViewLink() ? '/minu-andmed/õpingud' : '/töölaud/tunnistused/lõputunnistused') | translatePath) + '/' + certificate.id"
                      attr.aria-label="{{ 'button.open' | translate }} {{ certificate.issuerName }} {{ certificate.typeName }}"
                      [attr.data-test-id]="'certificates-graduation-certificates-link-' + certificate.id"
                      [state]="{from: linkState}"
                    >{{ 'button.view_more' | translate }}</a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </scrollableContent>
    </ng-template>
  </accordion-item>
  <accordion-item [title]="accordionSections[1].title"
    (click)="dataController(accordionSections[1].id)">
    <ng-template>
      @if (!error && !professionalCertificates) {
        <loader></loader>
      }
      @if (error && !certificateErr) {
        <p class="text-center text--substrong--head mb-0">
          {{ 'frontpage.dashboard_tabs_certificates_error_technical' | translate }}
        </p>
      }
      @if (error && certificateErr) {
        <p class="text-center text--substrong--head mb-0">
          {{ certificateErr }}
        </p>
      }
      @if (professionalCertificates && professionalCertificates.length < 1) {
        <p
          class="text-center text--substrong--head mb-0">
          {{ 'frontpage.dashboard_tabs_certificates_no_results' | translate }}
        </p>
      }
      @if (!error && professionalCertificates && professionalCertificates.length > 0) {
        <table htm-table>
          <tbody>
            @for (certificate of professionalCertificates; track certificate) {
              <tr>
                <td>{{ certificate.nimi | titlecase }}</td>
                <td>{{ certificate.valjaantud }}</td>
                <td class="text-center">
                  <a [routerLink]="('tunnistused' | translateWord) + '/' + certificate.registrinumber"
                    attr.aria-label="{{ 'button.view_more' | translate }} {{ certificate.nimi}}"
                    [attr.data-test-id]="'certificates-professional-certificate-link-' + certificate.registrinumber"
                  [state]="{certificate:certificate}">{{ 'button.view_more' | translate }}</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </ng-template>
  </accordion-item>
  <accordion-item [title]="accordionSections[2].title"
    (click)="dataController(accordionSections[2].id)">
    <ng-template>
      @if (!examResultsErr && !errRequest && !examResults) {
        <loader></loader>
      }
      @if (examResultsErr || errRequest) {
        @if (examResultsErr) {
          <p class="text-center text--substrong--head mb-0">
            {{ examResultsErr }}
          </p>
        }
        @if (errRequest) {
          <p class="text-center text--substrong--head mb-0">
            {{ 'errors.examinations_data_request' | translate }}
          </p>
        }
      }
      @if (!examResultsErr && !errRequest && examResults) {
        <table htm-table>
          <thead>
            <tr>
              <th>{{'frontpage.eksamiNimetus' | translate}}</th>
              <th>{{'frontpage.aasta' | translate}}</th>
              <th aria-hidden="true"></th>
            </tr>
          </thead>
          <tbody>
            @for (session of examResults; track session) {
              <tr>
                <td>{{ session.nimi }}</td>
                <td>{{ session.oppeaasta }}</td>
                <td class="text-center">
                  <a [routerLink]="('tunnistused' | translateWord) + '/' + session.testsessioon_id"
                    attr.aria-label="{{ 'button.view_more' | translate }} {{ session.nimi}}"
                    [attr.data-test-id]="'certificates-exam-result-link-' + session.testsessioon_id"
                  [state]="{exams: session.oppeaasta}">{{ 'button.view_more' | translate }}</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </ng-template>
  </accordion-item>
</accordion>
